import manager from "../Manager";

function GreetingPreview({ data, index, inEditor, structures }) {

    return (
        <div className="tbcourse-template tbcourse-template-greeting" key={index}>
            <div>
                <div className="tbcourse-template-greeting-title">{data?.title ? data.title : structures.title?.placeholder}</div>
                <div className="tbcourse-template-greeting-description" dangerouslySetInnerHTML={{ __html: data?.description ? data.description : manager.inEditor ? structures.description.placeholder : '' }}></div>
            </div>
        </div>
    )
}

export default GreetingPreview;
